"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.button.title': '显示键盘快捷键',
};
